import { motion } from 'framer-motion';
import { AnimatedCounter } from '../ui/AnimatedCounter';
import { TrendingUp, Users, FileCheck, ThumbsUp, Briefcase, Shield } from 'lucide-react';

const stats = [
  { value: 10000, suffix: '+', label: 'Businesses Registered', icon: Users, color: 'text-cyan-600 dark:text-cyan-400', bg: 'from-cyan-500/10 to-cyan-500/5', border: 'border-cyan-500/20' },
  { value: 10, prefix: '₹', suffix: ' Cr+', label: 'Loans Facilitated', icon: TrendingUp, color: 'text-purple-600 dark:text-purple-400', bg: 'from-purple-500/10 to-purple-500/5', border: 'border-purple-500/20' },
  { value: 50000, suffix: '+', label: 'GST Filings Done', icon: FileCheck, color: 'text-blue-600 dark:text-blue-400', bg: 'from-blue-500/10 to-blue-500/5', border: 'border-blue-500/20' },
  { value: 35, suffix: '+', label: 'Expert Services', icon: Briefcase, color: 'text-amber-600 dark:text-amber-400', bg: 'from-amber-500/10 to-amber-500/5', border: 'border-amber-500/20' },
  { value: 98, suffix: '%', label: 'Client Satisfaction', icon: ThumbsUp, color: 'text-green-600 dark:text-green-400', bg: 'from-green-500/10 to-green-500/5', border: 'border-green-500/20' },
  { value: 22, suffix: '+', label: 'Free Business Tools', icon: Shield, color: 'text-rose-600 dark:text-rose-400', bg: 'from-rose-500/10 to-rose-500/5', border: 'border-rose-500/20' },
];

export function Stats() {
  return (
    <section className="py-10 md:py-20 bg-slate-50/50 dark:bg-[#0B1A30] relative overflow-hidden">
      {/* Decorative lines */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-cyan-500/30 to-transparent" />
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-blue-500/30 to-transparent" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-2xl md:text-3xl font-black text-slate-900 dark:text-white">
            Trusted by <span className="bg-gradient-to-r from-cyan-500 to-blue-600 bg-clip-text text-transparent">Thousands</span> of Indian MSMEs
          </h2>
          <p className="text-slate-500 dark:text-slate-400 mt-2 text-sm font-medium">Real numbers. Real impact. Real businesses.</p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {stats.map((stat, index) => (
            <motion.div
              key={stat.label}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.08, duration: 0.5 }}
              className={`relative text-center group bg-gradient-to-b ${stat.bg} bg-white dark:bg-[#1A2A4A] border ${stat.border} rounded-2xl p-5 hover:scale-105 transition-transform duration-300`}
            >
              {/* Icon */}
              <div className={`inline-flex p-2.5 rounded-xl bg-white dark:bg-[#111C2F] border border-slate-200 dark:border-[#1E2A3A] shadow-sm mb-3 ${stat.color}`}>
                <stat.icon className="w-5 h-5" />
              </div>
              <AnimatedCounter
                value={stat.value}
                prefix={stat.prefix || ''}
                suffix={stat.suffix || ''}
                label={stat.label}
              />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
